import type { Step } from "react-joyride";

export const leaveEntitlementByEmployeeTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້າສິດລາຕໍ່ພະນັກງານ. ເບິ່ງສິດລາທຸກປະເພດຂອງພະນັກງານທີ່ເລືອກ ຄົງເຫຼືອ ແລະ ໃຊ້ແລ້ວ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="leave-entitlement-by-employee-back"]',
    content: "ກັບຄືນສູ່ຫນ້າສິດລາຕໍ່ປີ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="leave-entitlement-by-employee-cards"]',
    content: "ບັດສິດລາຕໍ່ປະເພດລາ ຄົງເຫຼືອ ແລະ ວັນໃຊ້ແລ້ວ.",
    placement: "top",
  },
];
